const AUTH_EXPIRED_CODE = '2051';
const UNAUTHORIZED_CODE = '401';
const INVALID_JWT_CODE = '1000';
const APP_LOGOUT_HANDLER = 'authExpired';

let hasAuthExpired = false;

function findAuthExpiredPayload(response) {
    let current = response;
    let depth = 0;

    while (current && typeof current === 'object' && depth < 3) {
        const code = String(current.code);
        const message = String(current.message || '');
        const isInvalidJwt = code === INVALID_JWT_CODE &&
            message.indexOf('JWT strings must contain exactly 2 period characters') > -1;
        if (Number(current.status) === 401 ||
            code === AUTH_EXPIRED_CODE ||
            code === UNAUTHORIZED_CODE ||
            isInvalidJwt) {
            return current;
        }
        current = current.response || current.data;
        depth++;
    }

    return null;
}

function replaceTimeoutMessage(response) {
    let current = response;
    let depth = 0;

    while (current && typeof current === 'object' && depth < 3) {
        current.message = 'Time out!';
        if (current.error && typeof current.error === 'object') {
            current.error.message = 'Time out!';
        }
        current = current.response || current.data;
        depth++;
    }
}

export function isAuthExpiredResponse(response) {
    return hasAuthExpired || Boolean(findAuthExpiredPayload(response));
}

export function getAuthExpiredMessage(response, fallbackMessage) {
    const payload = findAuthExpiredPayload(response);
    if (payload && String(payload.code) === AUTH_EXPIRED_CODE) {
        return 'Time out!';
    }
    return fallbackMessage;
}

export function notifyAppLogout(response) {
    if (!hasAuthExpired && !findAuthExpiredPayload(response)) {
        return;
    }

    const bridge = window.flutter_inappwebview;
    if (bridge && typeof bridge.callHandler === 'function') {
        Promise.resolve(bridge.callHandler(APP_LOGOUT_HANDLER)).catch((error) => {
            console.error('Failed to notify app of expired authentication.', error);
        });
        return;
    }

    console.warn('Flutter WebView bridge is unavailable; app logout was not notified.');
}

export default function handleAuthExpired(response) {
    const payload = findAuthExpiredPayload(response);
    if (!payload) {
        return false;
    }

    if (String(payload.code) === AUTH_EXPIRED_CODE) {
        replaceTimeoutMessage(response);
    }

    hasAuthExpired = true;
    return true;
}